import { MatchContumacy as MatchContumacyType } from '@amf/shared/data/Match';
import { useTranslate } from '@tolgee/react';

interface MatchContumacyProps {
  type: MatchContumacyType;
}

function MatchContumacy({ type }: MatchContumacyProps) {
  const { t } = useTranslate();
  if (type === null) return null;
  return (
    <div className='Contumacy'>
      <h2 className='Contumacy__title'>{t('match.contumacy.title')}</h2>
      <p className='Contumacy__message'>
        {type === 'home' && t('match.contumacy.message.home')}
        {type === 'away' && t('match.contumacy.message.away')}
        {type === 'both' && t('match.contumacy.message.both')}
      </p>
    </div>
  );
}

export default MatchContumacy;
